import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray } from 'redux-form';

import 'components/tenant_app/components/tenant_profile/TenantProfile.css';

import { SelectField } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import validate from '../validate';

import { AccentColor } from 'helpers/AccentColorHelper';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import scrollIntoView from 'scroll-into-view';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import { colors } from 'helpers/ColorHelper';

import * as validator from 'helpers/Validator';
import FileErrorBreakdown from '../FileErrorBreakdown';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import styled from 'styled-components';

const StyledH3 = styled.h3`
  font-size: 30px;
  margin-bottom: 20px;
  font-family: 'Circular-Bold';
  text-align: center;
`;

const StyledH4 = styled.h4`
  margin-bottom: 15px;
  font-family: 'Circular';
  text-align: center;
`;

const StyledFileErrorHeader = styled.p`
  color: red;
  font-family: 'Circular-Black';
  font-size: 15px;
  text-align: center;
`;

const MAX_NUMBER_OF_FILE_UPLOADS_PER_TYPE = 5;

class WizardFormNinthPage extends Component {
  openDocument = (url) => {
    window.open(decodeURI(url));
  };

  render() {
    const { handleSubmit, previousPage, submitting } = this.props;

    const style = {
      button: {
        color: 'white',
        float: 'right',
        height: '40px',
      },
      backButton: {
        float: 'left',
        color: AccentColor(),
        height: '40px',
      },
    };

    return (
      <div id="top" style={{ marginTop: '50px' }}>
        <StyledH3>
          {getTranslatedString('tenantPortal.tenantApplication.fileUpload.header')}
        </StyledH3>
        <StyledH4>{getTranslatedString('tenantPortal.tenantApplication.fileUpload.body')}</StyledH4>
        {this.props.fileErrors.length !== 0 && (
          <div>
            <StyledFileErrorHeader>
              {getTranslatedString('tenantPortal.fileErrorBreakdown.header')}
            </StyledFileErrorHeader>
            {this.props.fileErrors.map((file) => {
              return (
                <FileErrorBreakdown fileName={file.file_name} mimeType={file.stripped_mime_type} />
              );
            })}
          </div>
        )}

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row" style={{ marginTop: '20px' }}>
            <h5
              style={{
                textAlign: 'center',
                fontSize: '18px',
                marginBottom: '5px',
              }}
            >
              {getTranslatedString('tenantPortal.application.idUpload.proofIncome')}
            </h5>
            <FieldArray name="income_proofs" component={ProofOfIncomeFileUpload} />
          </div>
          {!this.props.overrideID && (
            <div className="row" style={{ marginTop: '30px' }}>
              <h5
                style={{
                  textAlign: 'center',
                  fontSize: '18px',
                  marginTop: '20px',
                  marginBottom: '5px',
                }}
              >
                {getTranslatedString('tenantPortal.application.idUpload.id')}
              </h5>
              <FieldArray name="id_proofs" component={ProofOfIdentityFileUpload} />
            </div>
          )}
          <div id="button" style={{ marginBottom: '75px' }} />
          <hr />
          <div id="application_footerbar">
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
              <FlatButton
                label={getTranslatedString('tenantPortal.application.idUpload.button.back')}
                type="button"
                className="previous"
                onClick={previousPage}
                backgroundColor="#fff"
                hoverColor="grey"
                style={style.backButton}
              />
              <FlatButton
                label={getTranslatedString('tenantPortal.application.idUpload.button.submit')}
                type="submit"
                className="next"
                primary={true}
                disabled={submitting}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

WizardFormNinthPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormNinthPage);

WizardFormNinthPage = connect((state) => ({
  initialValues: state.tenantApplication.tenantApplication,
}))(WizardFormNinthPage);

export default WizardFormNinthPage;

class ProofOfIncomeFileUpload extends Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (fields.length === 0) fields.push();
  }

  render() {
    return <ProofOfIncomeFileUploadFieldArray {...this.props} startDeletingAtIndex={1} />;
  }
}

const ProofOfIncomeFileUploadFieldArray = ({
  fields,
  meta: { error, submitFailed },
  startDeletingAtIndex,
}) => (
  <div style={{ marginBottom: '16px' }}>
    {fields.map((incomeProofFile, index) => (
      <div className="row" style={{ textAlign: 'center' }} key={`identityProofFile-${index}`}>
        <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
          <h4 style={{ lineHeight: '26px' }}>
            {getTranslatedString('tenantPortal.application.idUpload.proof.income', {
              index: index + 1,
            })}
            {
              <DeleteButton
                fields={fields}
                index={index}
                startDeletingAtIndex={startDeletingAtIndex}
              />
            }
          </h4>
        </div>
        <div className="col-md-12">
          <Field
            name={`${incomeProofFile}.sub_type`}
            component={SelectField}
            floatingLabelText={getTranslatedString(
              'tenantPortal.application.idUpload.documentType'
            )}
            style={{
              marginTop: '-30px',
              fontSize: '14px',
              textAlign: 'left',
              width: '60%',
            }}
            errorStyle={{ fontSize: '14px' }}
            validate={[validator.required]}
          >
            <MenuItem
              value={'Pay Stub'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.payStub'
              )}
            />
            <MenuItem
              value={'Letter of Employment'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.letter'
              )}
            />
            <MenuItem
              value={'Bank Statement'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.bank'
              )}
            />
            <MenuItem
              value={'Income Assistance'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.assistance'
              )}
            />
            <MenuItem
              value={'Separation Maintenance'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.separation'
              )}
            />
            <MenuItem
              value={'Student Loans'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.studentLoan'
              )}
            />
            <MenuItem
              value={'Other'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.proof.income.other'
              )}
            />
          </Field>
        </div>

        <div className="col-md-12">
          <Field
            name={`${incomeProofFile}.file`}
            component={ReduxDropzone}
            style={{
              border: `1px dashed ${colors.LIGHT_GRAY}`,
              width: '40%',
              margin: 'auto',
              textAlign: 'center',
            }}
            fileValidation=".jpeg, .png, .jpg, application/pdf"
            size={100}
            maxFileSize={15000000}
            labelText={getTranslatedString('tenantPortal.application.idUpload.clickToAdd')}
            maxNumberOfFilesUpload={1}
            validate={[validator.required]}
          />
        </div>
      </div>
    ))}
    <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
      {fields.length < MAX_NUMBER_OF_FILE_UPLOADS_PER_TYPE && (
        <FlatButton
          label={getTranslatedString('tenantPortal.application.idUpload.add.documents')}
          type="button"
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={{ color: 'white' }}
          onClick={() => {
            fields.push({});
          }}
        />
      )}
    </div>
  </div>
);

class ProofOfIdentityFileUpload extends Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    return <ProofOfIdentityFileUploadFieldArray {...this.props} startDeletingAtIndex={1} />;
  }
}

const ProofOfIdentityFileUploadFieldArray = ({
  fields,
  meta: { error, submitFailed },
  startDeletingAtIndex,
}) => (
  <div style={{ marginBottom: '16px' }}>
    {fields.map((identityProofFile, index) => (
      <div className="row" style={{ textAlign: 'center' }} key={`identityProofFile-${index}`}>
        <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
          <h4 style={{ lineHeight: '26px' }}>
            {getTranslatedString('tenantPortal.application.idUpload.proof.identity', {
              index: index + 1,
            })}
            {
              <DeleteButton
                fields={fields}
                index={index}
                startDeletingAtIndex={startDeletingAtIndex}
              />
            }
          </h4>
        </div>

        <div className="col-md-12">
          <Field
            name={`${identityProofFile}.sub_type`}
            component={SelectField}
            floatingLabelText={getTranslatedString(
              'tenantPortal.application.idUpload.documentType'
            )}
            style={{
              marginTop: '-30px',
              fontSize: '14px',
              textAlign: 'left',
              width: '60%',
            }}
            errorStyle={{ fontSize: '14px' }}
            validate={[validator.required]}
          >
            <MenuItem
              value={'Citizenship Card'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.identity.citizenship'
              )}
            />
            <MenuItem
              value={'Drivers License'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.identity.license'
              )}
            />
            <MenuItem
              value={'Federal ID Card'}
              primaryText={getTranslatedString('tenantPortal.application.idUpload.identity.fedID')}
            />
            <MenuItem
              value={'Military ID Card'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.identity.millitary'
              )}
            />
            <MenuItem
              value={'Passport'}
              primaryText={getTranslatedString(
                'tenantPortal.application.idUpload.identity.passport'
              )}
            />
            <MenuItem
              value={'State/Provincial ID Card'}
              primaryText={getTranslatedString('tenantPortal.application.idUpload.identity.state')}
            />

            {/** apparently grouping these together in a react fragment breaks the formatting, so they are done individually */}
            {featureEnabled('ui.applications_page.show_id_types') && (
              <MenuItem
                value={'Permanent Resident Card'}
                primaryText={getTranslatedString(
                  'tenantPortal.application.idUpload.identity.residentCard'
                )}
              />
            )}
            {featureEnabled('ui.applications_page.show_id_types') && (
              <MenuItem
                value={'Student ID'}
                primaryText={getTranslatedString(
                  'tenantPortal.application.idUpload.identity.studentID'
                )}
              />
            )}
            {featureEnabled('ui.applications_page.show_id_types') && (
              <MenuItem
                value={'Work Permit'}
                primaryText={getTranslatedString(
                  'tenantPortal.application.idUpload.identity.workPermit'
                )}
              />
            )}

            <MenuItem
              value={'Other'}
              primaryText={getTranslatedString('tenantPortal.application.idUpload.identity.other')}
            />
          </Field>
        </div>

        <div className="col-md-12">
          <Field
            name={`${identityProofFile}.file`}
            component={ReduxDropzone}
            style={{
              border: `1px dashed ${colors.LIGHT_GRAY}`,
              width: '40%',
              margin: 'auto',
              textAlign: 'center',
            }}
            size={100}
            maxFileSize={15000000}
            fileValidation=".jpeg, .png, .jpg, application/pdf"
            labelText={getTranslatedString('tenantPortal.application.idUpload.clickToAdd')}
            maxNumberOfFilesUpload={1}
            validate={[validator.required]}
          />
        </div>
      </div>
    ))}
    <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
      {fields.length < MAX_NUMBER_OF_FILE_UPLOADS_PER_TYPE && (
        <FlatButton
          label={getTranslatedString('tenantPortal.application.idUpload.add.documents')}
          type="button"
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={{ color: 'white' }}
          onClick={() => {
            fields.push({});
          }}
        />
      )}
    </div>
  </div>
);

const DeleteButton = ({ fields, index, startDeletingAtIndex = 0 }) => {
  if (index < startDeletingAtIndex) return null;

  if (index >= startDeletingAtIndex) {
    return (
      <IconButton
        style={{
          padding: 0,
          verticalAlign: 'text-bottom',
          width: 'none',
          height: 'none',
          float: 'right',
          marginBottom: '15px',
        }}
        onClick={() => {
          fields.remove(index);
        }}
      >
        <DeleteIcon size={24} style={{ padding: 0 }} />
      </IconButton>
    );
  }
};
